<template>
    <div class="login-dialog--login__content-container--text">
        <h2 class="login-dialog--login__content-container--text__title primary-font">{{title}}</h2>
        <span class="login-dialog--login__content-container--text__subtitle secondary-font" :style="layout == 'portal' ? '' : 'color: #222222'">{{description}}</span><br>
        <span v-if="email !== '' && email !== null && email !== undefined && email.includes('@')  && email.includes('.')" class="login-dialog--login__content-container--text__subtitle font-weight-bold">{{email}}</span>
        <otc-input placeholder="" activeInputClass="active-input-class" @on-complete="onCompleteHandler"
            :inputValue="code" :layout="layout" @on-changed="onChangedHandler" :isValid="!error.length" @on-paste="onPasteHandler" @verify="submit"/>
        <p v-if="error" class="pt-5 red--text">{{error}}</p>
        <p v-if="!error && showResendText" :class="$vuetify.breakpoint.smAndDown ? 'mt-8' : 'mt-5'" style="line-height: 18px; font-size: 14px">Vi har forsøkt å sende deg koden på nytt. {{isSms ? 'Vent litt på ny SMS og prøv igjen.' : 'Vent litt på ny e-post og prøv igjen. Sjekk gjerne også om den kan ha havnet i “søppelposten” i e-posttjenesten du bruker'}}</p>
        <p v-if="showJunkMailText && !showResendText" class="pt-5">Sjekk søppelpost om du ikke har mottatt koden.</p>
    </div>
</template>
<script>
import { OtcInput } from '../CommonComponents'
export default {
    name: "the-identifier",
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: false,
            default: ''
        },
        layout: {
            type: String,
            required: false,
            default: 'chain'
        },
        error: {
            required: false,
            default: '',
            type: String
        },
        showResendText: {
            required: false,
            default: false,
            type: Boolean
        },
        showJunkMailText: {
            required: false,
            default: false,
            type: Boolean
        },
        isSms: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    components: {
        OtcInput
    },
    data() {
        return {
            code: ''
        };
    },
    methods: {
        onCompleteHandler(e) {
            this.$emit("setValue", e);
        },
        onChangedHandler(e) {
            this.$emit('changed')
        },
        onPasteHandler(e) {
            this.$emit("setValue", e);
            this.submit();
        },
        obscureEmail(email)  {
            if (email.includes('@') && email.includes('.')) {
                const [name, domain] = email.split("@");
                const [host, ext] = domain.split(".")
                return `${ name[0] }${ new Array(name.length).join("*") }@${ new Array(host.length).join("*") }${ host[host.length-1] }.${ ext }`
            } else {
                return 'email.'
            }
        },
        submit(){
            this.$emit("verify");
        }
            
    }
};
</script>

<style lang="scss"></style>